/**
 * 微信jssdk，Vue插件
 */
import { getJsSignature } from '@/api/wechat'

const shareJsApiList = [
  'onMenuShareQQ',
  'onMenuShareWeibo',
  'onMenuShareQZone',
  'onMenuShareTimeline',
  'onMenuShareAppMessage'
  // 'updateAppMessageShareData',
  // 'updateTimelineShareData'
]

export var wechatJsSdk = null
var init_error = false

/**
 * Vue插件, 将$wechatJsSdk(Promise)挂载到Vue的原型上
 * @param {*} Vue
 * @param {*} options { jsApiList}
 */
export const install = function (Vue, options = {}) {
  const { defaultShare, template } = options
  if (!Vue) return console.error('Vue参数应该是一个Vue构造函数.')
  if (!wechatJsSdk) {
    wechatJsSdk = INSTALL({
      jsApiList: options.jsApiList
    })
  }
  Vue.prototype.$wechatJsSdk = wechatJsSdk
  // 如果为true，有上交默认分享为首页
  if (defaultShare) {
    setDefaultShareInfo()
  }
  if (template) {
    share(template)
  }
}

/**
 * 给当前页面配置微信分享
 * @param {Object} {} 微信分享所需要的数据
 * @returns {Promise} 微信jsskd的wx对象
 */
export const share = function ({ title, desc, link, imgUrl, success, cancel }) {
  if (!wechatJsSdk) wechatJsSdk = INSTALL()
  //  防止域名被屏蔽
  const linkRedirectUrl = 'https://edu.leziedu.com/cms/webapp/home/redirect.html?url='
  const template = {
    title,
    desc,
    link: `${linkRedirectUrl}${encodeURIComponent(link)}`,
    imgUrl,
    success,
    cancel
  }

  return wechatJsSdk.then((wx) => {
    // 分享
    shareJsApiList.forEach((api) => {
      wx[api](template)
    })
    return wx
  })
}

/**
 * 获取微信sdk的配置项
 * @param {Object} {jsApiList: 微信api列表}
 * @returns {Object} 微信jssdk的配置项
 */
function getConfig({ jsApiList = [] }) {
  const url = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
    ? location.origin + location.pathname + location.search
    : location.href
  return getJsSignature(url).then((res) => {
    return {
      debug: false,
      appId: res.data.appId,
      timestamp: res.data.timestamp,
      nonceStr: res.data.nonceStr,
      signature: res.data.signature,
      jsApiList: jsApiList.concat(shareJsApiList)
    }
  })
}


function watiForSharpUrl() {
  return new Promise((resolve) => {
    var interval = setInterval(() => {
      if (location.href.includes('#')) {
        resolve(true)
        clearInterval(interval)
      }
    }, 200)
  })
}

/**
 * 配置微信jssdk
 * @param {Object} { jsApiList: 微信api列表 }
 * @returns { Promise } 微信jssdk的wx对象
 */
function INSTALL(options = {}) {
  return new Promise(function (resolve, reject) {
    watiForSharpUrl().then(() => {
      let curUrl = location.href
      try {
        getConfig({
          jsApiList: options.jsApiList ? options.jsApiList : []
        })
          .then(function (config) {
            window.wx.config(config)
            window.wx.ready(function () {
              resolve(window.wx)
            })
            window.wx.error(function (error) {
              console.error(error);
              console.error(`请求前url:${curUrl}`);
              console.error(`当前url:${location.href}`);
              reject(error)
            })
          })
          .catch((err) => {
            reject(err)
          })
      } catch (e) {
        reject(e)
      }
    })
  })
}

/**
 * 设置首页分享出去的内容
 */
export function setDefaultShareInfo() {
  return share({
    title: '1-9年级电子教材',
    desc: '新华书店唯一指定授权,作业检查利器,强烈推荐！',
    link: `https://${window.location.host}/cms/webapp/home/answer/index.html?fromUrl=share`,
    imgUrl: `https://${window.location.host}/cms/static/images/logo-128.png`,
    success: function () { },
    cancel: function () { }
  })
}
